<template>
  <CHeader with-subheader style="background-color: #929C8B !important;">
    <CToggler in-header class="ml-3 d-lg-none" @click="$store.commit('toggleSidebarMobile')" />
    <CToggler in-header class="ml-3 d-md-down-none" @click="$store.commit('toggleSidebarDesktop')" />
    <CHeaderBrand class="mx-auto d-lg-none" :to="{ path: '/home' }">
      <img src="logo_confirmame.png" alt="Logo Confirmame" style="height: 40px;" />
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto">
      <CHeaderNavItem class="px-12">
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav>
      <TheHeaderDropdownAccnt @updateEventCode="updateEventCode" @updateEventPlanner="updateEventPlanner" />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import router from '../router/index'
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
  },
  data() {
    return {
    }
  },
  mounted: async function () {
  },
  methods: {
    logout: function () {
      localStorage.removeItem("account");
      localStorage.removeItem("token");

      router.push("login");
    },
    updateEventCode() {
      this.$emit("updateEventCode");
    },
    updateEventPlanner() {
      this.$emit("updateEventPlanner");
    },
  }
}
</script>
